// application
import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";
import { ModelRequest, VehicleFiltersRequest } from "@/main/models/request";

export abstract class IModelApi {
	abstract getVehicleModel(request: ModelRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;

	abstract getVehicleModelByFilters(request: VehicleFiltersRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
